function cov_2d3bupwfki() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/GarageFilled.tsx";
  var hash = "1f88fa7b914f79f93f00faf685b90be4b1161dca";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/GarageFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1f88fa7b914f79f93f00faf685b90be4b1161dca"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2d3bupwfki = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2d3bupwfki();
var Icon = (cov_2d3bupwfki().s[0]++, {
  name: 'garage-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.30934 7.4498L5.39761 6.95435C5.75887 4.92664 7.52208 3.4498 9.58172 3.4498H14.6709C16.8475 3.4498 18.6723 5.09421 18.898 7.25904L18.9179 7.4498H20.75C21.4404 7.4498 22 8.00944 22 8.6998C22 9.39015 21.4404 9.9498 20.75 9.9498H19.1786L19.2059 10.2114C20.8611 11.0265 22 12.7301 22 14.6998C22 15.67 21.7237 16.5756 21.2454 17.3423C21.2485 17.3778 21.25 17.4136 21.25 17.4498V20.4498C21.25 21.1402 20.6904 21.6998 20 21.6998C19.3096 21.6998 18.75 21.1402 18.75 20.4498V19.385C18.2053 19.5885 17.6157 19.6998 17 19.6998H7C6.38434 19.6998 5.79467 19.5885 5.25 19.385V20.4498C5.25 21.1402 4.69036 21.6998 4 21.6998C3.30964 21.6998 2.75 21.1402 2.75 20.4498V17.4498C2.75 17.4136 2.75154 17.3778 2.75456 17.3423C2.27632 16.5756 2 15.67 2 14.6998C2 12.7201 3.15058 11.0091 4.81953 10.199L4.86394 9.9498H3.25C2.55964 9.9498 2 9.39015 2 8.6998C2 8.00944 2.55964 7.4498 3.25 7.4498H5.30934ZM7.85885 7.39285C8.0076 6.55791 8.73363 5.9498 9.58172 5.9498H14.6709C15.5672 5.9498 16.3185 6.62691 16.4115 7.51831L16.639 9.6998H7.44784L7.85885 7.39285ZM7.5 14.6998C7.5 15.3902 6.94036 15.9498 6.25 15.9498C5.55964 15.9498 5 15.3902 5 14.6998C5 14.0094 5.55964 13.4498 6.25 13.4498C6.94036 13.4498 7.5 14.0094 7.5 14.6998ZM17.75 15.9498C18.4404 15.9498 19 15.3902 19 14.6998C19 14.0094 18.4404 13.4498 17.75 13.4498C17.0596 13.4498 16.5 14.0094 16.5 14.6998C16.5 15.3902 17.0596 15.9498 17.75 15.9498ZM9 14.6998C9 14.1475 9.44772 13.6998 10 13.6998H14C14.5523 13.6998 15 14.1475 15 14.6998C15 15.2521 14.5523 15.6998 14 15.6998H10C9.44772 15.6998 9 15.2521 9 14.6998Z\" fill=\"currentColor\"/>"
});
export default Icon;